import { Type, Image as ImageIcon, QrCode, Quote } from 'lucide-react';

import { createTextBlock, serializeTextBlock } from './textBlock';
import TextBlockLayer from './TextBlockLayer';
import TextPropertiesPanel from './TextPropertiesPanel';
import { createImageBlock, serializeImageBlock } from './imageBlock';
import ImageBlockLayer, { IMAGE_RESOURCES } from './ImageBlockLayer';
import ImagePropertiesPanel from './ImagePropertiesPanel';
import { createQRBlock, serializeQRBlock } from './qrBlock';
import QRBlockLayer from './QRBlockLayer';
import QRPropertiesPanel from './QRPropertiesPanel';

// The single type -> component/behavior lookup the grid engine uses for
// every block-type interaction (add-block menu, canvas layer, properties
// panel, serialization). Adding a block type means adding an entry here —
// PrintableMasterGrid and the add-block menu never branch on `type` name.
const BLOCK_TYPES = [
  {
    type: 'text',
    label: 'Text',
    icon: Type,
    create: createTextBlock,
    serialize: serializeTextBlock,
    Layer: TextBlockLayer,
    PropertiesPanel: TextPropertiesPanel,
  },
  {
    type: 'image',
    label: 'Logo',
    icon: ImageIcon,
    create: createImageBlock,
    serialize: serializeImageBlock,
    Layer: ImageBlockLayer,
    PropertiesPanel: ImagePropertiesPanel,
    // Add-block menu offers one button per variant instead of the single
    // default `label`/`icon` button above — same underlying 'image' type
    // and blocksByType bucket, just a different default resourceKey (and
    // starting size, to match each asset's aspect ratio).
    variants: [
      { label: 'Logo', icon: ImageIcon, overrides: { resourceKey: IMAGE_RESOURCES.DEFAULT_LOGO, width: 1, height: 1 } },
      { label: 'Slogan', icon: Quote, overrides: { resourceKey: IMAGE_RESOURCES.DEFAULT_SLOGAN, width: 3, height: 0.5 } },
    ],
  },
  {
    type: 'qr',
    label: 'QR',
    icon: QrCode,
    create: createQRBlock,
    serialize: serializeQRBlock,
    Layer: QRBlockLayer,
    PropertiesPanel: QRPropertiesPanel,
  },
];

export default BLOCK_TYPES;
